var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.group.name))]),_c('div',[_vm._v(_vm._s(_vm.group.description))]),_c('div',[_vm._v(_vm._s(_vm.group.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }